'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = require('../../managewidgets/components/textfield/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _ButtonStandard = require('../../managewidgets/components/button/ButtonStandard');

var _ButtonStandard2 = _interopRequireDefault(_ButtonStandard);

var _AuthenticationSite = require('./AuthenticationSite.scss');

var _AuthenticationSite2 = _interopRequireDefault(_AuthenticationSite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthenticationSite = function (_Component) {
  (0, _inherits3.default)(AuthenticationSite, _Component);

  function AuthenticationSite(props) {
    (0, _classCallCheck3.default)(this, AuthenticationSite);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AuthenticationSite.__proto__ || (0, _getPrototypeOf2.default)(AuthenticationSite)).call(this, props));

    _this.handleLogin = function () {
      // if (!this.state.siteText || this.state.siteText.indexOf('https://') === -1) {
      //   alert('Please enter a valid site URL (with https://)');
      //   return;
      // }

      _this.props.onSiteLogin(_this.state.site);
    };

    _this.handleSiteChange = function (text) {
      _this.setState({
        site: text
      });
    };

    _this.handleSiteKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.handleLogin();
      }
    };

    _this.state = {
      site: ''
    };
    return _this;
  }

  (0, _createClass3.default)(AuthenticationSite, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _AuthenticationSite2.default.wrap },
        _react2.default.createElement(
          'div',
          { className: _AuthenticationSite2.default.container },
          _react2.default.createElement(
            'div',
            null,
            'Site:'
          ),
          _react2.default.createElement(_TextField2.default, {
            className: _AuthenticationSite2.default.text,
            autoFocus: true,
            value: this.state.site,
            placeholder: 'https://na.myconnectwise.net',
            onChange: this.handleSiteChange,
            onKeyPress: this.handleSiteKeyPress,
            automationName: 'site'
          }),
          _react2.default.createElement(_ButtonStandard2.default, { automationName: 'login', value: 'Login', onClick: this.handleLogin })
        )
      );
    }
  }]);
  return AuthenticationSite;
}(_react.Component);

exports.default = AuthenticationSite;


AuthenticationSite.propTypes = {
  onSiteLogin: _propTypes2.default.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/authentication/AuthenticationSite.js
// module id = 321
// module chunks = 10